$('select[name="reportStudentID"]').change(function () {
    window.location = base_url + 'attendances/dashboard/' + $(this).val();
});
